"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Filter_1 = __importDefault(require("../Filter"));
const Types_1 = require("Types");
const Typography_1 = require("../Typography");
const Button_1 = __importDefault(require("../../Button"));
const style = __importStar(require("./styled"));
const Badge_1 = __importDefault(require("../Badge"));
const Hooks_1 = require("@/Hooks");
const svg_components_1 = require("@/assets/svg-components");
const palette_1 = require("@/Theme/palette");
const safeDecode_1 = require("app/Utils/safeDecode");
const FilterList = ({ filters, setIsFilterOpen, productsAmount, hideSearch, clearFilters, onSearch, setSearch, activeFilters, setActiveFilters, search, showMoreLabel, searchPlaceholder, isLiteratureFilter, fromValue, setFromValue, toValue, setToValue, shouldChangeSearchIconToClose = false, isProductListing = false, count, isSearchPage = false, }) => {
    var _a;
    const { isMobile, isDesktop, isDesktopSmall } = (0, Hooks_1.useDevice)();
    const { t } = (0, Hooks_1.useTranslate)();
    const clearAll = () => {
        clearFilters === null || clearFilters === void 0 ? void 0 : clearFilters();
    };
    const removeFilter = (item) => {
        setActiveFilters(prev => prev.filter(e => e.id !== item.id));
    };
    return (react_1.default.createElement(style.Container, { isProductListing: isProductListing, isDesktopSmall: isDesktopSmall, isMobile: !isDesktop },
        react_1.default.createElement("div", null,
            (!isDesktop || (isProductListing && isDesktopSmall)) && (react_1.default.createElement(style.IconContainer, null,
                react_1.default.createElement(svg_components_1.BurgerClosedIcon, { onClick: () => setIsFilterOpen(false) }))),
            react_1.default.createElement(style.TitleRow, null,
                react_1.default.createElement(style.TitleContainer, null,
                    react_1.default.createElement(style.Title, { type: Typography_1.Types.BODY_1 }, t('/haldex/filter/title')),
                    (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 0 && react_1.default.createElement(Badge_1.default, { label: (_a = activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) === null || _a === void 0 ? void 0 : _a.toString() })),
                react_1.default.createElement(Button_1.default, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: clearAll },
                    react_1.default.createElement(style.ButtonText, { type: Typography_1.Types.BODY_1 }, t('/haldex/filter/clear_all')))),
            (activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.length) > 0 && (react_1.default.createElement(style.Row, null, activeFilters === null || activeFilters === void 0 ? void 0 : activeFilters.map(item => (react_1.default.createElement(style.ActiveFilterContainer, { key: item.id, onClick: () => removeFilter(item) },
                react_1.default.createElement(style.ActiveFilterLabel, { type: Typography_1.Types.BODY_2 }, item.name),
                react_1.default.createElement(style.RemoveIcon, { fill: palette_1.palette.DARK_GRAY_80, strokeWidth: 3 })))))),
            !hideSearch && (react_1.default.createElement(style.SearchContainer, null,
                react_1.default.createElement(style.SearchInput, { placeholder: searchPlaceholder !== null && searchPlaceholder !== void 0 ? searchPlaceholder : t('/haldex/filter/search_placeholder'), type: 'search', onChange: e => {
                        setSearch && setSearch(encodeURIComponent(e.target.value));
                    }, value: (0, safeDecode_1.safeDecode)(search), shouldRemoveDefaultCancelButton: shouldChangeSearchIconToClose }),
                shouldChangeSearchIconToClose && search ? (react_1.default.createElement(style.ClearButton, { onClick: () => {
                        setSearch && setSearch('');
                    } },
                    react_1.default.createElement(svg_components_1.CrossIcon, null))) : (react_1.default.createElement(style.SearchButton, { onClick: () => {
                        onSearch && onSearch();
                    } },
                    react_1.default.createElement(svg_components_1.SearchIcon, null))))), filters === null || filters === void 0 ? void 0 :
            filters.map((filter, i) => (react_1.default.createElement(Filter_1.default, { key: i, label: filter.label, items: filter.items, activeFilters: activeFilters, setActiveFilters: setActiveFilters, isLast: (filters === null || filters === void 0 ? void 0 : filters.length) === i + 1, isLiteratureFilter: isLiteratureFilter, fromValue: fromValue, setFromValue: setFromValue, toValue: toValue, setToValue: setToValue })))),
        (isMobile || isDesktopSmall) && isSearchPage && (react_1.default.createElement(Button_1.default, { variant: Types_1.ButtonVariants.ONLY_TEXT, onClick: () => setIsFilterOpen(false) },
            react_1.default.createElement(style.ButtonApplyFilters, { type: Typography_1.Types.BODY_1 },
                t('/haldex/filter/show_more_products'),
                " (",
                count,
                ")"))),
        (isMobile || (isProductListing && isDesktopSmall)) && showMoreLabel && (react_1.default.createElement(style.ButtonContainer, null,
            react_1.default.createElement(style.ShowButton, { isMobile: isMobile, onClick: () => setIsFilterOpen(false) },
                showMoreLabel,
                " ",
                productsAmount ? `(${productsAmount})` : '')))));
};
exports.default = (0, react_1.memo)(FilterList);
